import React from 'react';
import LegalPageShell from '../components/LegalPageShell';

const sections = [
  {
    num: 1,
    title: 'Acceptance of Terms',
    content: (
      <p>
        By creating an account, downloading the app, or making a purchase on Taraanaya, you agree to
        be bound by these Terms of Service (&ldquo;Terms&rdquo;) and our
        {' '}<a href="/privacy-policy">Privacy Policy</a>. If you do not agree, please do not use the service.
        We may update these Terms from time to time; the &ldquo;last updated&rdquo; date reflects the
        most recent version. Continued use after an update constitutes acceptance.
      </p>
    ),
  },
  {
    num: 2,
    title: 'Eligibility',
    content: (
      <p>
        You must be 18 years of age or older and an Indian resident to purchase paid subscriptions or
        credit packs. Users between 13 and 18 may use the free preview only with verifiable parental
        or guardian consent in line with the Digital Personal Data Protection Act, 2023. Persons under
        13 are not permitted to use Taraanaya.
      </p>
    ),
  },
  {
    num: 3,
    title: 'Nature of the Service',
    content: (
      <p>
        Taraanaya provides Vedic astrology content for personal entertainment, reflection, and
        decision-support. Predictions are generated using Vedic algorithms and AI interpretation, and
        are <strong>not</strong> medical, legal, financial, or psychiatric advice. They should not be
        used as the sole basis for important life decisions. We make no guarantee that any predicted
        outcome will materialise.
      </p>
    ),
  },
  {
    num: 4,
    title: 'Subscriptions, Credits &amp; Billing',
    content: (
      <>
        <p>Taraanaya offers two product categories:</p>
        <ul>
          <li><strong>30-day Subscription Plans</strong> &mdash; Starter (&#8377;199), Premium (&#8377;599), Ultimate (&#8377;999).</li>
          <li><strong>Sage AI Question Credit Packs</strong> &mdash; Small (&#8377;199), Medium (&#8377;599), Large (&#8377;999); credits never expire.</li>
        </ul>
        <p>All prices are in Indian Rupees (INR), inclusive of 18% GST (SAC 998599).</p>
        <ul>
          <li><strong>Web (taraanaya.ai):</strong> Subscriptions are non-auto-renewing &mdash; you renew manually.</li>
          <li><strong>Android (Google Play):</strong> Subscriptions auto-renew unless cancelled in your Google Play account at least 24 hours before the next billing cycle.</li>
          <li><strong>iOS (Apple App Store):</strong> Subscriptions auto-renew unless cancelled in your Apple ID subscription settings at least 24 hours before the next billing cycle.</li>
        </ul>
        <p>Detailed refund rules are available in our <a href="/refund-policy">Refund &amp; Cancellation Policy</a>.</p>
      </>
    ),
  },
  {
    num: 5,
    title: 'User Conduct',
    content: (
      <ul>
        <li>You will not misuse the service, attempt to reverse-engineer, scrape, or copy our content.</li>
        <li>You will not resell, sub-license, or commercially exploit any content obtained from Taraanaya.</li>
        <li>You will not impersonate another person, submit fraudulent payment details, or create accounts using false information.</li>
        <li>You will not use Taraanaya for any unlawful purpose, including astrology-based fraud, fortune-telling scams, or harassment of others.</li>
        <li>We reserve the right to suspend or terminate any account found in violation of these Terms.</li>
      </ul>
    ),
  },
  {
    num: 6,
    title: 'Intellectual Property',
    content: (
      <p>
        All content on Taraanaya &mdash; including the Vedic algorithms, narrations, videos,
        voiceovers, illustrations, brand marks (&ldquo;taraanaya&rdquo; wordmark, logo, star arc),
        software code, and copy &mdash; is the exclusive property of Taraanaya Vedtech Private
        Limited and is protected by Indian and international copyright, trademark, and trade-secret
        laws. A limited, personal, non-transferable, non-commercial licence is granted to you upon
        successful purchase, solely for your private use.
      </p>
    ),
  },
  {
    num: 7,
    title: 'Privacy &amp; Data Protection',
    content: (
      <p>
        We process your personal data in accordance with the Digital Personal Data Protection Act,
        2023. Please review our <a href="/privacy-policy">Privacy Policy</a> for details on what we
        collect, how we use it, and how to exercise your rights.
      </p>
    ),
  },
  {
    num: 8,
    title: 'Limitation of Liability',
    content: (
      <p>
        To the maximum extent permitted by Indian law, Taraanaya Vedtech Private Limited&rsquo;s
        aggregate liability arising out of or in connection with the service is limited to the total
        amount you paid us in the 12 months preceding the claim. We disclaim warranties of fitness
        for a particular purpose, accuracy of predictions, and uninterrupted availability of the
        service.
      </p>
    ),
  },
  {
    num: 9,
    title: 'Termination',
    content: (
      <p>
        You may delete your account at any time by writing to
        {' '}<a href="mailto:taraanaya@taraanaya.ai">taraanaya@taraanaya.ai</a>. We may suspend or
        terminate access for breach of these Terms, suspected fraud, or as required by law. Upon
        termination, your access ends immediately; outstanding subscriptions are subject to the
        Refund Policy.
      </p>
    ),
  },
  {
    num: 10,
    title: 'Governing Law &amp; Jurisdiction',
    content: (
      <p>
        These Terms are governed by and construed in accordance with the laws of India. The courts of
        Gautam Buddha Nagar, Uttar Pradesh shall have exclusive jurisdiction over any dispute arising
        from or related to these Terms or your use of the service.
      </p>
    ),
  },
  {
    num: 11,
    title: 'Contact',
    content: (
      <p>
        Questions about these Terms? Email <a href="mailto:taraanaya@taraanaya.ai">taraanaya@taraanaya.ai</a>{' '}
        or visit our <a href="/contact">Contact page</a>.
      </p>
    ),
  },
];

export default function TermsOfService() {
  return (
    <LegalPageShell
      title="Terms of Service"
      lastUpdated="20 September 2026"
      sections={sections}
      dataTestId="terms-of-service-page"
    />
  );
}
